import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import history from '../../utils/history';

class NotificationPopUp extends React.Component {
  handleClick = () => {
    this.props.openFreePopUp(false);
    history.push('/app/manage-subscription');
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={() => this.props.openFreePopUp(false)}
          className="suscription-expired subscription-expired-free modal-dialog-centered"
        >
          <ModalHeader tag="div" className="danger">
            <i className="icon-lock big-icon" />
            <h4>This is a paid feature</h4>
          </ModalHeader>
          <ModalBody>
            To continue, please upgrade your subscription to access this feature
          </ModalBody>
          <ModalFooter>
            <Button color="primary" size="xs" block onClick={this.handleClick}>
              MANAGE MY SUBSCRIPTION
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default NotificationPopUp;
